module.exports = __webpack_public_path__ + "img/ru_success_5.f9f01385.png";